<div class="heading">HALT, STOP!!!</div>
<div class="description">Du bist nicht autorisiert diese Seite zu besuchen!</div>
<div (click)="home()" class="home">Gehe zurück auf Los!</div>
